import { useCallback, useRef, useState } from "react";

// Evita el doble envío: mientras hay un envío en curso, cualquier otro intento
// se ignora. Usa un ref además del estado porque dos clics seguidos pueden
// llegar antes de que React vuelva a renderizar (y con él, deshabilite el botón).
export const useEnvioUnico = () => {
  const enCurso = useRef(false);
  const [enviando, setEnviando] = useState(false);

  const ejecutar = useCallback(async (fn) => {
    if (enCurso.current) return undefined;
    enCurso.current = true;
    setEnviando(true);
    try {
      return await fn();
    } finally {
      enCurso.current = false;
      setEnviando(false);
    }
  }, []);

  return { enviando, ejecutar };
};
